<template>
  <div class="vm-block-payment">
    <icon-pay-group :tuijian_type="'bank'" :list="pay_list" :is_hide_lijian="true" :pay_type="pay_type" @select_pay="select_pay"></icon-pay-group>
    <template v-if="pay_type == 'bank' && bank.name">
      <div class="flex-box lh1 mt40" v-if="!is_bank_edit">
        <div class="black-3" style="width:96px">
          <p>{{$t('c.BlockPayment.text1')}}</p>
          <p class="mt32">{{$t('c.BlockPayment.text40')}}</p>
          <p class="mt32">{{$t('c.BlockPayment.text2')}}</p>
          <p class="mt32">{{$t('c.BlockPayment.text3')}}</p>
        </div>
        <div class="">
          <p>{{bank.name}}</p>
          <p class="mt32">{{bank.bank_name}}</p>
          <p class="mt32">{{bank.bank_acct_no}}</p>
          <p class="mt32">{{bank.mobile_number}}</p>
        </div>
      </div>
      <!-- 银行入口下掉 -->
      <!-- <div v-if="!is_bank_edit && bank.account_type == 1 && !is_hide_withdraw_user" class="mt40"><span class="underline pointer" style="color: #946ce6 !important" @click="tab_edit_bank(true)">换绑银行卡</span></div> -->
    </template>
    <template v-if="pay_type == 'bank' && !bank.name && !is_hide_withdraw_user">
      <div class="purple mt-mq">{{$t('c.BlockPayment.text4')}}</div>
      <div>
        <input type="text" class="gl-input" :placeholder="$t('c.BlockPayment.text38')" v-model="name"/>
      </div>
      <div class="purple mt-mq">{{$t('c.BlockPayment.text5')}}</div>
      <div class="relative">
        <input type="text" class="gl-input" :placeholder="$t('c.BlockPayment.text6')" v-model="number" />
      </div>
      <div class="purple mt-mq">{{$t('c.BlockPayment.text7')}}</div>
      <div class="flex-box mt16">
        <div class="relative id-card black-3 fs12 lh1 flex-box flex-center mr16">
          <span v-if="!copy_src">{{$t('c.BlockPayment.text8')}}</span>  
          <pic v-if="copy_src" :src="copy_src" width="85" height="54" ></pic>
          <vue-core-image-upload
            class="gl-upload"
            :crop="false"
            @imageuploaded="image_upload_front"
            @errorhandle="errorhandle"
            @imageuploading="image_uploading_front"
            text
            :inputOfFile="upload.name"
            :max-file-size="upload.max_file_size"
            :url="upload.id_card_url"/>
        </div>
        <div class="relative id-card black-3 fs12 lh1 flex-box flex-center mr16">
          <span v-if="!national_src">{{$t('c.BlockPayment.text9')}}</span>  
          <pic v-if="national_src" :src="national_src" width="85" height="54" ></pic>
          <vue-core-image-upload
            class="gl-upload"
            :crop="false"
            @imageuploaded="image_upload_back"
            @errorhandle="errorhandle"
            @imageuploading="image_uploading_back"
            text
            :inputOfFile="upload.name"
            :max-file-size="upload.max_file_size"
            :url="upload.id_card_url"/>
        </div>
      </div>
      <div class="purple mt-mq flex-box flex-a-center">{{$t('c.BlockPayment.text10')}}
      <div class="flex-box flex-a-center ml24 black-3"><checkbox class="pointer" v-model="is_longtime">{{$t('c.BlockPayment.text11')}}</checkbox></div>
      </div>
      <div class="flex-box flex-a-center mt8">
        <date-picker type="date" format="YYYY-MM-DD" value-type="format" :placeholder="$t('c.BlockPayment.text12')" :editable="false" v-model="begin_time"></date-picker>
        <span class="ml16 mr16 fs14 black-3">{{$t('c.BlockPayment.text13')}}</span>  
        <date-picker v-if="!is_longtime" type="date" format="YYYY-MM-DD" value-type="format" :placeholder="$t('c.BlockPayment.text14')" :editable="false" v-model="end_time"></date-picker>
        <span v-if="is_longtime" class="black-8">{{$t('c.BlockPayment.text15')}}</span>
      </div>
      <div class="purple mt-mq">{{$t('c.BlockPayment.text16')}}</div>
      <div>
        <input type="text" class="gl-input" :placeholder="$t('c.BlockPayment.text17')" v-model.trim="bank_acct_no"/>
      </div>
      <div class="purple mt-mq">{{$t('c.BlockPayment.text18')}}</div>
      <div class="mt8">
        <tag class="white pointer fs14 pl12 pr12" v-if="bank_branch_code" @click.native="remove_bank_name">{{bank_name}}</tag>
      </div>
      <div v-if="!bank_branch_code" class="relative">
        <input type="text" class="gl-input" :placeholder="$t('c.BlockPayment.text19')" v-model.trim="bank_name" />
        <!-- <input type="hide" :value="bank_code"/> -->
        <div class="search-list" v-if="bank_name_list.length > 0">
          <div class="item" v-for="(item, i) in bank_name_list" :key="i" v-if="i < 5" @click="set_bank_name(item)">{{item.name}}</div>
        </div>
      </div>
      <!-- <div class="purple mt-mq">开户行支行{{bank_branch_code}}</div>
      <div class="relative">
        <input type="text" class="gl-input" placeholder="例：北京朝外大街支行" v-model.trim="bank_branch_name"/>
        <div class="search-list" v-if="bank_branch_name_list.length > 0">
          <div class="item" v-for="(item, i) in bank_branch_name_list" :key="i" v-if="i < 5" @click="set_bank_branch_name(item)">{{item.name}}</div>
        </div>
      </div> -->
      <div class="purple mt-mq">{{$t('c.BlockPayment.text3')}}</div>
      <div class="relative">
        <input type="text" class="gl-input phone-input" :placeholder="$t('c.BlockPayment.text20')" v-model.trim="mobile_number"/>
        <span v-if="!is_sent" class="fs16 purple phone-code gl-hover-text-purple" @click="get_sms_code">{{$t('c.BlockPayment.text21')}}</span>
        <span v-if="is_sent" class="fs16 phone-code black-3">{{$t('c.BlockPayment.text22')}}（<span>{{ time }}</span>s）</span>
      </div>
      <div class="mt12" v-if="is_show_msg_code">
        <input type="text" class="gl-input" :placeholder="$t('c.BlockPayment.text23')" v-model="sms_code"/>
      </div>
      <div class="tip-box mt16 fs14">{{$t('c.BlockPayment.text24')}}</div>
      <div class="error-box mt16 fs14" v-if="em">{{em}}</div>
      <btn class="look6 pt12 pb12 pl64 pr64 fs16 mt40" :class="{w100: browser_size == 'small'}" @click.native="save_bank">{{$t('c.BlockPayment.text25')}}</btn>
    </template>

    <template v-if="pay_type != 'bank' && !is_hide_withdraw_user">
      <template v-if="pay_type != 'paypal' && (pay_type == 'alipay' || alipay.realname)">
        <div class="purple mt-48-24 mq">{{$t('c.BlockPayment.text26')}}</div>
        <div>
          <input type="text" class="gl-input" v-model="account" :placeholder="$t('c.BlockPayment.text27')" />
        </div>
        <div class="purple mt-48-24 mq">{{$t('c.BlockPayment.text28')}}</div>
        <div>
          <input type="text" class="gl-input" v-model="realname" :placeholder="$t('c.BlockPayment.text29')" />
        </div>
      </template>

      <template v-if="pay_type != 'alipay' && (pay_type == 'paypal' || paypal.realname)">
          <div class="mt-48-24 mq black-5 fs12">
              {{$t('c.BlockPayment.text30')}}
          </div>
        <div class="purple mt-48-24 mq">{{$t('c.BlockPayment.text31')}}</div>
        <div>
          <input type="text" class="gl-input" v-model="account" :placeholder="$t('c.BlockPayment.text32')" />
        </div>
        <div class="purple mt-48-24 mq">{{$t('c.BlockPayment.text33')}}</div>
        <div>
          <input type="text" class="gl-input" v-model="realname" :placeholder="$t('c.BlockPayment.text34')" />
        </div>
      </template>
      <div class="flex-box mt-48-24 mq">
        <btn class="look6 pt12 pb12 pl64 pr64 fs16" :class="{w100: browser_size == 'small'}" @click.native="save">{{$t('c.BlockPayment.text35')}}</btn>
        <!-- <btn text="保存" class="size32 mq" @click.native="save"></btn> -->
      </div>
    </template>
    <div v-if="!bank.name && !is_hide_withdraw_user" class="black-5 fs12 mt16">
      <p>{{$t('c.BlockPayment.text36')}}</p>
      <p>{{$t('c.BlockPayment.text37')}}</p>
    </div>
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker'; //https://github.com/mengxiong10/vue2-datepicker/blob/master/README.zh-CN.md
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/zh-cn';
import { mapState } from "vuex";
import {
  GET_BANG_SEARCH_BANK,
  GET_BANG_SEARCH_BRANCH_BANK,
  GET_BANG_SEARCH_CITY,
  GET_BANG_SMS_CODE,
  POST_BANG_CUS_APPLICATION,
  POST_BANG_CUS_APPLICATION_RENEW,
  POST_EDIT_WITHDRAW,
  GET_WITHDRAW_METHOD,
} from "@/api/config";
export default {
  name: "block-payment",
  components:{
    DatePicker
  },
  props: {
    is_show_bank: {
      default() {
        // return true; //下掉银行入口
        return false;
      },
    },
    default_init: {
      default() {
        return '';
      },
    },
  },
  data() {
    return {
      pay_type: "",
      realname: "",
      account: "",
      alipay:{},
      paypal:{},
      bank:{},
      ENV:this.GL.ENV,
      default_val_map:{
        'alipay': 1,
        'paypal': 2,
        'bank': 3,
      },
      default_type_map:{
        1: 'alipay',
        2: 'paypal',
        3: 'bank',
      },

      copy:'',    //身份证人像
      copy_src:'',
      national:'',  //身份证国徽
      national_src:'',
      number:'',
      valid_time:'',
      begin_time:'',
      end_time:'',
      is_longtime:false,

      mobile_number:'',
      name:'',
     
      bank_name:'',
      bank_name_search_lock:false,
      bank_name_list:[],

      // bank_branch_name:'',
      // bank_branch_name_search_lock:false,
      // bank_branch_name_list:[],

      bank_acct_no:'', //银行卡号
      bank_code:'', //银行编码 xx银行
      bank_branch_code:'', //开户行联行号 xx银行xx支行
      // bank_address_code:'', // 开户行所在地编码
      sms_code:'', //验证码

      is_sent: false,
      is_show_msg_code:false,
      time: 60,
      go: null,
      em:'',

      is_bank_edit:false,
    };
  },
  watch:{
    pay_type(newValue){
        if(newValue == 'alipay' || newValue == 'paypal'){
          this.realname = this[newValue].realname || ''
          this.account = this[newValue].account || ''
        }
    },
    bank_name(v){
      if(v != '' && !this.bank_name_search_lock){
        this.$debounce(() => {
          this.search_bank()
        }, 500)
      }
    },
    // bank_branch_name(v){
    //   if(v != '' && !this.bank_branch_name_search_lock){
    //     this.$debounce(() => {
    //       this.search_branch_bank()
    //     }, 500)
    //   }
    // },
    time(val) {
      if (val == 0) {
          this.time = 60;
          this.is_sent = false;
          if (this.go) {
              clearInterval(this.go);
              this.go = null;
          }
      }
    },
  },
  computed: {
    ...mapState("app", ["session_user", "user_status", "browser_size",'upload','white_list']),
    // can_edit_bank(){
    //   return this.session_user && this.white_list.BANK_EDIT_USERS.indexOf(this.session_user.user_id) != -1;
    // },
    // is_test_edit_user(){
    //   return this.session_user && this.session_user.user_id == '80a0b7b47ff211ea990952540025c377'
    // },
    is_hide_withdraw_user(){
      return this.session_user && this.white_list.WITHDRAW_HIDE_USERS.indexOf(this.session_user.user_id) != -1;
    },
    pay_list(){
        let re = ['alipay'];
        if(this.is_hide_withdraw_user){
          return ['bank']
        }
        if(this.is_show_bank){
          re.unshift('bank')
        }
        if(this.ENV.is_abroad == 1){
            re.push('paypal')
        }
        if(this.bank.name || this.is_bank_edit){
          return ['bank']
        }
        return re;
    },
    post_data() {
      return {
        realname: this.realname,
        account: this.account,
        type: this.default_val_map[this.pay_type]
        //  this.pay_type == 'paypal' ? 2 : 1,
      };
    },
    bank_post_data(){
      return {
        copy:this.copy,    //身份证人像
        national:this.national,  //身份证国徽
        number:this.number,
        name:this.name,
        valid_time:this.begin_time + ',' + (this.is_longtime ? '长期' : this.end_time),
        mobile_number:this.mobile_number,
        bank_acct_no:this.bank_acct_no, //银行卡号
        bank_code:this.bank_code, //银行编码 xx银行
        bank_branch_code:this.bank_code, //银行编码 xx银行 
        // bank_address_code:this.bank_address_code, // 开户行所在地编码
        // profession:'49900',  //职业，默认传这个吧
        sms_code:this.sms_code, //验证码
      }
    },
    edit_bank_post_data(){
      return {
        mobile_number:this.mobile_number,
        bank_acct_no:this.bank_acct_no, //银行卡号
        bank_code:this.bank_code, //银行编码 xx银行
        bank_branch_code:this.bank_code, //银行编码 xx银行
        sms_code:this.sms_code, //验证码
      }
    },
    is_creator() {
      if (
        this.session_user &&
        this.session_user.creator &&
        this.session_user.creator.status
      ) {
        return true;
      }
      return false;
    }
  },
  mounted() {
    this.get_withdraw();
  },
  methods: {
    select_pay(data){
        this.pay_type = data.type;
        this.$nextTick(() => {
          this.$bus.$emit('FOOTER_LOCATION')
        });
    },
    timimg() {
        this.go = setInterval(() => {
            this.time--;
        }, 1000);
    },
    image_uploading_front(file) {
      window.URL = window.URL || window.webkitURL;
      this.copy_src = window.URL.createObjectURL(file);
    },
    image_upload_front(data) {
      if (data.ec != 200) {
        this.$notify({
          title: data.em,
          group: 'error',
        });
      }
      this.copy = data.data.media_id;
    },
    image_uploading_back(file) {
      window.URL = window.URL || window.webkitURL;
      this.national_src = window.URL.createObjectURL(file);
    },
    image_upload_back(data) {
      if (data.ec != 200) {
        this.$notify({
          title: data.em,
          group: 'error',
        });
      }
      this.national = data.data.media_id;
    },
    errorhandle(err_text) {
      if (/FILE IS TOO LARGER MAX FILE/.test(err_text)) {
        err_text = `上传文件最大为: ` + err_text.split(' ').pop();
      }
      this.$notify({
        title: err_text,
        group: 'error',
      });
      // this.is_file_uploading = false;
    },
    set_bank_name(item){
      this.bank_name = item.name;
      this.bank_name_search_lock = true;
      this.bank_branch_code = item.code;
      this.bank_code = item.code;
      this.bank_name_list = [];
      this.$nextTick(() => {
        this.bank_name_search_lock = false;
      })
    },
    remove_bank_name(){
      this.bank_name = '';
      this.bank_branch_code = '';
      this.bank_name_list = [];
    },
    async search_bank() {
      if (this.$http.is_run(GET_BANG_SEARCH_BANK)) {
          return false;
      }
      let data = await this.$http.$axios(GET_BANG_SEARCH_BANK,{
        name:this.bank_name
      });
      if(data.ec == 200){
        this.bank_name_list = data.data.list
      }
    },
    // set_bank_branch_name(item){
    //   this.bank_branch_name = item.name;
    //   this.bank_branch_name_search_lock = true;
    //   this.bank_branch_code = item.bank_code;
    //   this.bank_branch_name_list = [];
    //   this.$nextTick(() => {
    //     this.bank_branch_name_search_lock = false;
    //   })
    // },
    // async search_branch_bank() {
    //   if (this.$http.is_run(GET_BANG_SEARCH_BRANCH_BANK)) {
    //       return false;
    //   }
    //   let data = await this.$http.$axios(GET_BANG_SEARCH_BRANCH_BANK,{
    //     name:this.bank_branch_name
    //   });
    //   if(data.ec == 200){
    //     this.bank_branch_name_list = data.data
    //   }
    // },
    async get_sms_code() {
      if (this.$http.is_run(GET_BANG_SMS_CODE)) {
          return false;
      }
      let data = await this.$http.$axios(GET_BANG_SMS_CODE,{
        mobile_number:this.mobile_number
      });
      if(data.ec != 200){
        this.$notify({
          title: data.em,
          group: 'error',
        });
        return false;
      }
      this.is_sent = true;
      this.is_show_msg_code = true;
      this.timimg();
    },
    tab_edit_bank(value){
      this.bank.name = '' 
      this.is_bank_edit = value
      this.$nextTick(() => {
        this.$bus.$emit('FOOTER_LOCATION')
      })
    },
    // async edit_bank() {
    //   if (this.$http.is_run(POST_BANG_CUS_APPLICATION_RENEW)) {
    //     return false;
    //   }
    //   let data = await this.$http.$axios(POST_BANG_CUS_APPLICATION_RENEW, this.edit_bank_post_data);
    //   if(data.ec != 200){
    //     this.em = data.em
    //   }
    //   if(data.ec == 200){
    //     this.$notify({
    //       title: data.em,
    //       group: "success"
    //     });
    //     this.get_withdraw();
    //     this.$nextTick(() => {
    //       this.tab_edit_bank(false)
    //     })
    //   }
    // },
    async save_bank() {
      let API = this.is_bank_edit ? POST_BANG_CUS_APPLICATION_RENEW : POST_BANG_CUS_APPLICATION;
      if (this.$http.is_run(API)) {
          return false;
      }
      let data = await this.$http.$axios(API,this.bank_post_data);
      if(data.ec != 200){
        this.em = data.em
      }
      if(data.ec == 200){
        this.$notify({
          title: data.em,
          group: "success"
        });
        this.get_withdraw();
        if(this.is_bank_edit){
          this.$nextTick(() => {
              this.is_bank_edit = false;
          })
        }
      }
    },
    async save() {
      if (this.$http.is_run(POST_EDIT_WITHDRAW)) {
        return false;
      }
      let data = await this.$http.$axios(POST_EDIT_WITHDRAW, this.post_data);

      this.$notify({
        title: data.em,
        group: data.ec == 200 ? "success" : "error"
      });
      if (data.ec == 200) {
        this.$emit("save");
        this.$store.dispatch("app/set:session_user"); //保存成功更新session_user状态
      }
    },
    async get_withdraw() {
      if (this.$http.is_run(GET_WITHDRAW_METHOD)) {
        return false;
      }
      let data = await this.$http.$axios(GET_WITHDRAW_METHOD);

      if (data.ec != 200) {
        this.$notify({
          title: data.em,
          group: "error"
        });
        return false;
      }
      this.pay_type = this.default_type_map[data.data.default]
      this.alipay = data.data.alipay
      this.paypal = data.data.paypal
      this.bank = data.data.bang

      if(this.paypal.realname ){
        this.pay_type = 'paypal'
      }
      if(this.default_init && !this.alipay.realname && !this.paypal.realname && !this.bank.name){
        this.pay_type = this.default_type_map[this.default_init]
      }
      
    }
  }
};
</script>

<style lang="stylus" scoped>
.vm-block-payment {
  .tip-box{
    background: rgba(252, 178, 57, 0.1);
    border: 1px solid #FCB239;
    box-sizing: border-box;
    border-radius: 2px;
    padding:12px 20px;
  }
  .error-box{
    background: rgba(215, 64, 97, 0.1);
    border: 1px solid #D74061;
    box-sizing: border-box;
    border-radius: 2px;
    padding:12px 20px;
    color:rgba(215, 64, 97, 1);
  }
  .phone-input{
    padding-right: 120px;
    box-sizing: border-box;
  }
  .phone-code{
    position:absolute;
    right:0;
    top:50%;
    transform:translate(0, -50%);
  }
  .id-card{
    width:85px;
    height:54px;
    background: rgba(0, 0, 0, 0.05);
    border-radius: 2px;
    overflow: hidden;
  }
  .search-list{
    position: absolute;
    left: 0%;
    right: 0%;
    bottom: 0%;
    transform:translate(0, 100%);

    background: $white;
    border: 1px solid $black-1;
    box-sizing: border-box;
    box-shadow: 0px 4px 10px $black-1;
    border-radius: 4px;
    color:$black-8;
    z-index:1;
    .item{
      padding:8px 12px;
      &:first-child{
        padding-top:16px;
      }
      &:last-child{
        padding-bottom:16px;
      }
      &:hover{
        cursor: pointer;
        background: $black-1;
      }
    }
  }

  .mt-mq {
    margin-top: 48px;
  }
  
  @media (max-width: $width-mobile) {
    .mt-mq{
      margin-top: 24px;
    }
  }

}
</style>
